export default __webpack_public_path__ + "static/rectangularwire-f7a16c2b65b647a05bb3bc4eae0c0c33.png";